var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalCloseIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12.7069L19.6465 20.3533L20.3536 19.6462L12.7071 11.9998L20.3536 4.35335L19.6465 3.64624L12 11.2927L4.35359 3.64624L3.64648 4.35335L11.2929 11.9998L3.64648 19.6462L4.35359 20.3533L12 12.7069Z",
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCloseIc);
export default __webpack_public_path__ + "static/media/modal_close_ic.a7ed59d0ad8f82de7e88a30d314a2123.svg";
export { ForwardRef as ReactComponent };